module.exports = __webpack_public_path__ + "static/media/creative-team-pana-business.a1c9340e.svg";